export const tableConfig = {
    selection: false,
    height: 357,
    columns: [
        {
            label: '客户编码',
            prop: 'customerCode',
            minWidth: 120
        },
        {
            label: '主客户编码',
            prop: 'belongCustomerCode',
            minWidth: 90
        },
        {
            label: '客户名称',
            prop: 'customerName',
            minWidth: 200
        },
        {
            label: '状态',
            prop: 'customerStatus',
            type: 'select',
            optionsKey: 'SYS_WM_CUSTOMER_STATUS',
            minWidth: 80
        },
        {
            label: '内外销客户',
            prop: 'isImpExpCustomer',
            type: 'select',
            optionsKey: 'SYS_WM_IN_OR_OUT_SALE_CUSTOMER',
            minWidth: 100
        },
        {
            label: '客户系',
            prop: 'customerGroupName',
            minWidth: 120
        },
        {
            label: '行业大类',
            prop: 'industryCategoriesName',
            minWidth: 90
        },
        {
            label: '细分行业',
            prop: 'industryType',
            type: 'select',
            optionsKey: 'SYS_INDUSTRY_TYPE',
            minWidth: 100
        },
        {
            label: '内外渠',
            prop: 'customerChannel',
            type: 'select',
            optionsKey: 'LMDM_CUSTOMER_CHANNEL',
            minWidth: 80
        },
        {
            label: '美的渠道角色',
            prop: 'customerChannelRole',
            type: 'select',
            optionsKey: 'LMDM_CUSTOMER_CHANNEL_ROLE',
            minWidth: 120
        },
        {
            label: '所属事业部',
            prop: 'ebcuBuCode',
            type: 'select',
            optionsKey: 'SYS_BUSINESS_UNIT',
            minWidth: 120
        },
        {
            label: '创建人',
            prop: 'createUserCode',
            minWidth: 120
        },
        {
            label: '创建时间',
            prop: 'createTime',
            minWidth: 150
        },
        {
            label: '修改人',
            prop: 'updateUserCode',
            minWidth: 120
        },
        {
            label: '修改时间',
            prop: 'updateTime',
            minWidth: 150
        }
    ]
};
